import React, { useState, useEffect } from 'react';
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import moment from 'moment-timezone';
import Moment from 'react-moment';
import { Typography, Grid, Box, Divider, FormControl, CircularProgress, Select, MenuItem, IconButton, ListItemIcon } from '@material-ui/core';
import ArrowDropDownCircleIcon from '@material-ui/icons/ArrowDropDownCircle';
import LabelIcon from '@material-ui/icons/Label';
import { makeStyles } from '@material-ui/core/styles';

import { CloudQueue, CloudOff, Warning, Error, CheckCircle, Sync, Assessment } from '@material-ui/icons';
import img_sum from '../images/sun.png';
import img_temp from '../images/temp.png';

import { stationRecordRequest } from '../actions/stationQueryAction';
import { ACTIVE_TIME } from '../config';

var startTime = moment().tz('Asia/Taipei').hour(ACTIVE_TIME.start_hour).minute(ACTIVE_TIME.start_minute).second(0).millisecond(0);
var endTime = moment().tz('Asia/Taipei').hour(ACTIVE_TIME.end_hour).minute(ACTIVE_TIME.end_minute).second(0).millisecond(0);

const useStyles = makeStyles(() => ({
    root: {
        fontSize: '0.8rem',
        textAlign: 'right',
    },
    dividerRoot: {
        padding: '6px 0 6px 0',
    },
    selectMenu: {
        fontSize: '0.5rem',
        paddingTop: 2,
        paddingBottom: 2,
    },
}));

const round = (x, p = 1, e) => {
    if (isFinite(x) && !isNaN(parseFloat(x))) {
        let color = 'green';

        if (!isNaN(parseFloat(e))) {
            if (x < e)
                color = 'red';
        }
        return <span style={{ color: color }}>{Math.round(x * 10 * p) / (10 * p)}</span>;
    } else {
        return isFinite(x) ? x : '---';
    }
};

var timeoutMinutes = 15;

const StationCell = ({ station, updating, refresh }) => {
    const style = useStyles();
    const record = useSelector(state => state.stationRecord[station.ID]);
    const dispatch = useDispatch();
    const [selectedInv, setSelectedInv] = useState('0');
    const [selectedMppt, setSelectedMppt] = useState(0);

    useEffect(() => {
        if (updating) {
            setSelectedInv('0');
            setSelectedMppt(0);
            dispatch(stationRecordRequest(station.ID));
        }

    }, [updating, dispatch, station.ID]);

    const onInverterChanged = (event) => {
        setSelectedMppt(0);
        setSelectedInv(event.target.value);
    }

    const onRefresh = (event) => {
        event.preventDefault();
        dispatch(stationRecordRequest(station.ID));
    };

    var activeTime = moment().tz('Asia/Taipei');

    if (!activeTime.isBefore(startTime) && !activeTime.isAfter(endTime))
        activeTime = activeTime.subtract(timeoutMinutes, 'm');


    var pyrano = undefined;
    var thermo = undefined;

    if (record && record.record && record.record.devices) {
        pyrano = record.record.devices.find(x => x.DeviceType === 'Pyrano' && moment.tz(x.CaptureTime, 'Asia/Taipei').isAfter(activeTime));
        thermo = record.record.devices.find(x => x.DeviceType === 'Thermo' && moment.tz(x.CaptureTime, 'Asia/Taipei').isAfter(activeTime));
    }

    var inverters = undefined;
    var inverterList = [];
    var mppts = {};
    var DC_V = '---';
    var DC_A = '---';
    var DC_W = '---';
    var AC_V = '---';
    var AC_A = '---';
    var AC_W = '---';
    var INV_TEMP = '---';
    var INV_EF = '---';
    var INV_EF_ALL = '---';
    var KW_TODAY = '---';
    var KW_TOTAL = '---';
    var KW_PER = '---';
    var KW_PER2 = '---';
    var DTY = '---';
    var RA = '---';
    var PR = '---';
    var CAP_TIME = '---';

    var DTY_STD = '---';
    var DTY_STD_DIFF = 0;
    var RA_STD = '---';
    var RA_STD_DIFF = 0;
    var PR_STD = '---';
    var PR_STD_DIFF = 0;
    var INV_EF_ALL_STD = '---';
    var INV_EF_ALL_STD_DIFF = 0;
    mppts['0'] = { count: 0, mppts: [] }

    if (station) {
        DTY_STD = 'DustStandard' in station && station.DustStandard !== null ? station.DustStandard : '---';
        DTY_STD_DIFF = 'DustAlarmRange' in station ? station.DustAlarmRange : 0;
        PR_STD = 'PRStandard' in station && station.PRStandard !== null ? station.PRStandard : '---';
        PR_STD_DIFF = 'PRAlarmRange' in station ? station.PRAlarmRange : 0;
        RA_STD = 'RAStandard' in station && station.RAStandard !== null ? station.RAStandard : '---';
        RA_STD_DIFF = 'RASunRange' in station ? station.RASunRange : 0;
        INV_EF_ALL_STD = 'AC2DCStandard' in station && station.AC2DCStandard !== null ? station.AC2DCStandard : '---';
        INV_EF_ALL_STD_DIFF = 'AC2DCAlarmRange' in station ? station.AC2DCAlarmRange : 0;

        DTY_STD_DIFF = !isNaN(parseFloat(DTY_STD)) ? DTY_STD - DTY_STD_DIFF : '---';
        PR_STD_DIFF = !isNaN(parseFloat(PR_STD)) ? PR_STD - PR_STD_DIFF : '---';
        RA_STD_DIFF = !isNaN(parseFloat(RA_STD)) ? RA_STD - RA_STD_DIFF : '---';
        INV_EF_ALL_STD_DIFF = !isNaN(parseFloat(INV_EF_ALL_STD)) ? INV_EF_ALL_STD - INV_EF_ALL_STD_DIFF : '---';

        if (station.inverters && station.inverters.length > 0) {
            inverterList = station.inverters.map(x => ({ index: x.IndexID, name: x.Name, kw: x.KW }));

            let count = 0;
            for (let i = 0; i < station.inverters.length; i++) {
                count = count + station.inverters[i].mppts.length;
                mppts[station.inverters[i].IndexID] = { count: station.inverters[i].mppts.length, mppts: station.inverters[i].mppts };
            }
            mppts['0'] = { count: count, mppts: [] };
        }
    }

    let StateIcon = Error;
    let StateIconColor = 'darkred';
    if (record && record.status === 2) {
        StateIcon = CheckCircle;
        StateIconColor = 'green';
    }

    if (record && !(record.status===1) && record.record && record.record.inverters && record.record.inverters.length > 0) {
        inverters = record.record.inverters;
        CAP_TIME = Math.max.apply(null, inverters.map(x => moment.tz(x.CaptureTime, 'Asia/Taipei').unix()));
        CAP_TIME = moment.tz(moment.unix(CAP_TIME).utc(), 'Asia/Taipei');
        let inverterError = false;
        inverters = inverters.filter(x => moment.tz(x.CaptureTime, 'Asia/Taipei').isAfter(activeTime));
        if (selectedInv === '0') {
            if (inverters.length > 0) {
                DC_V = DC_A = DC_W = AC_V = AC_A = AC_W = INV_TEMP = INV_EF = INV_EF_ALL = KW_TODAY = KW_TOTAL = KW_PER = KW_PER2 = DTY = RA = PR = 0;
                CAP_TIME = activeTime;
                inverters.forEach(x => {
                    let cap_time = moment.tz(x.CaptureTime,'Asia/Taipei');
                    if (cap_time.isAfter(CAP_TIME)) CAP_TIME = cap_time;
                    if ((x.DCCurrent1 + x.DCCurrent2 + x.DCCurrent3) === 0 || (x.ACCurrent1 + x.ACCurrent2 + x.ACCurrent3) === 0 ) {
                        inverterError = true;
                    }

                    DC_V = DC_V + (x.DCVoltage1 + x.DCVoltage2 + x.DCVoltage3 + x.DCVoltage4 + x.DCVoltage5 + x.DCVoltage6 + x.DCVoltage7 + x.DCVoltage8);


                    DC_A = DC_A + (x.DCCurrent1 + x.DCCurrent2 + x.DCCurrent3 + x.DCCurrent4 + x.DCCurrent5 + x.DCCurrent6 + x.DCCurrent7 + x.DCCurrent8);
                    DC_W = DC_W + (x.DCWattage1 + x.DCWattage2 + x.DCWattage3 + x.DCWattage4 + x.DCWattage5 + x.DCWattage6 + x.DCWattage7 + x.DCWattage8);
                    AC_V = AC_V + (x.ACVoltage1 + x.ACVoltage2 + x.ACVoltage3) / station.InverterEGPhase;

                    AC_A = AC_A + (x.ACCurrent1 + x.ACCurrent2 + x.ACCurrent3);
                    AC_W = AC_W + (x.ACWattage1 + x.ACWattage2 + x.ACWattage3);
//                    INV_EF = AC_W / DC_W * 100.0;
                    INV_EF = INV_EF + x.COFF;
                    INV_EF_ALL = INV_EF_ALL + x.AvgCOFF;
                    INV_TEMP = INV_TEMP + x.Temperature;
                    KW_TODAY = KW_TODAY + x.TodayEnergy;
                    KW_TOTAL = KW_TOTAL + x.TotalEnergy;
                    KW_PER = KW_PER + x.KWPERH;
                    KW_PER2 = KW_PER2 + x.KWPERH2;
                    DTY = DTY + x.AvgDUST;
                    RA = RA + x.AvgRA;
                    PR = PR + x.AvgPR;
                });
                //                    DC_V = DC_V / inverterList.length;

                DC_V = DC_V / mppts[selectedInv].count;
                AC_V = AC_V / inverterList.length;
                INV_TEMP = INV_TEMP / inverterList.length;
                INV_EF = INV_EF / inverterList.length;
                INV_EF_ALL = INV_EF_ALL / inverterList.length;
                KW_PER = KW_PER / inverterList.length;
                KW_PER2 = KW_PER2 / inverterList.length;
                DTY = DTY / inverterList.length;
                RA = RA / inverterList.length;
                PR = PR / inverterList.length;
            }
        } else {
            let x = inverters.find(v => (v.ID === selectedInv));
            if (x) {

                if (selectedMppt === 0) {
                    CAP_TIME =  moment.tz(x.CaptureTime, 'Asia/Taipei');
                    DC_V = (x.DCVoltage1 + x.DCVoltage2 + x.DCVoltage3 + x.DCVoltage4 + x.DCVoltage5 + x.DCVoltage6 + x.DCVoltage7 + x.DCVoltage8) / mppts[selectedInv].count;
                    DC_A = (x.DCCurrent1 + x.DCCurrent2 + x.DCCurrent3 + x.DCCurrent4 + x.DCCurrent5 + x.DCCurrent6 + x.DCCurrent7 + x.DCCurrent8);
                    DC_W = (x.DCWattage1 + x.DCWattage2 + x.DCWattage3 + x.DCWattage4 + x.DCWattage5 + x.DCWattage6 + x.DCWattage7 + x.DCWattage8);
                    AC_V = (x.ACVoltage1 + x.ACVoltage2 + x.ACVoltage3) / station.InverterEGPhase;
                    AC_A = (x.ACCurrent1 + x.ACCurrent2 + x.ACCurrent3);
                    AC_W = (x.ACWattage1 + x.ACWattage2 + x.ACWattage3);
                    INV_EF = x.COFF;
                    INV_EF_ALL = x.AvgCOFF;
                    INV_TEMP = x.Temperature;
                    KW_TODAY = x.TodayEnergy;
                    KW_TOTAL = x.TotalEnergy;
                    KW_PER = x.KWPERH;
                    KW_PER2 = x.KWPERH2;
                    DTY = x.AvgDUST;
                    RA = x.AvgRA;
                    PR = x.AvgPR;                    
                } else {
                    CAP_TIME =  moment.tz(x.CaptureTime, 'Asia/Taipei');
                    DC_V = x["DCVoltage" + selectedMppt];
                    DC_A = x["DCCurrent" + selectedMppt];
                    DC_W = x["DCWattage" + selectedMppt];
                    AC_V = "---";
                    AC_A = "---";
                    AC_W = "---";
                    INV_EF = "---";
                    INV_EF_ALL = "---";
                    INV_TEMP = x.Temperature;
                    KW_TODAY = "---";
                    KW_TOTAL = "---";
                    KW_PER = "---";
                    KW_PER2 = "---";
                    DTY = "---";
                    RA = "---";
                    PR = "---";
                }
                
                if (DC_A === 0 || AC_A === 0 ) {
                    inverterError = true;
                }
            }
        }

        if (!inverters || inverters.length === 0) {
            StateIcon = Error;
            StateIconColor = 'darkred';
        } else if ((inverters.length !== inverterList.length) || inverterError) {
            StateIcon = Warning;
            StateIconColor = 'orange';
        };
    }

    let refreshing = record && record.status === 1;

    let totalKw = '';
    if (inverterList && inverterList.length > 0) {
        totalKw = inverterList.reduce((acc, obj) => {
            return acc + obj.kw;
          }, 0);
        
          totalKw = Math.round(totalKw * 100) / 100;
    }

    if (inverters) {
        inverterList.forEach(x => {
            let cx = inverters.find(v => (v.ID === x.index));
            if (cx && (cx.DCCurrent1 + cx.DCCurrent2 + cx.DCCurrent3) !== 0 && (cx.ACCurrent1 + cx.ACCurrent2 + cx.ACCurrent3) !== 0) {
                x.inverterOk = true;
            } else {
                x.inverterOk = false;
            }
        });
    }

    let allInverterOk = inverterList.find(x => x.inverterOk === false || x.inverterOk === undefined) ? false : true;

    return (
        <Box borderRadius={10} boxShadow={3} border={1} borderColor="grey.500" bgcolor={refreshing ? 'rgba(0, 0, 0, 0.4)' : 'rgba(200, 200, 200, 0.6)'}>

            <Box p={1} display="flex" bgcolor="rgba(255, 255, 255, 0.5)" boxShadow={3} borderRadius={10}>
                <Box flexGrow={1} display="flex" alignContent="flex-end">
                    {record && record.status === 3 ?
                        <CloudOff /> : <CloudQueue />
                    }
                    <Box pl={1} pr={1} fontWeight="fontWeightBold">{station.ID} {station.Name}</Box>
                    {refreshing ?
                        <CircularProgress color="inherit" size="1.5rem" thickness={6} /> :
                        <StateIcon style={{ color: StateIconColor }} />
                    }
                </Box>
                <Box fontSize="0.9rem"><img src={img_sum} width="18" alt="sun" /> {pyrano ? Math.round(pyrano.DeviceValue * 10) / 10 : '---'}</Box>
                <Box pl={2} pr={2} fontSize="0.9rem"><img src={img_temp} width="18" alt="temp" /> {thermo ? Math.round(thermo.DeviceValue * 10) / 10 : '---'}°C</Box>
            </Box>

            <Box p={2} bgcolor="rgba(200, 200, 200, 0.5)">
                <Grid container spacing={2}>
                    <Grid item xs={7}>
                        <FormControl variant="outlined" size="small" fullWidth>
                            <Select variant="outlined" value={selectedInv} classes={{ selectMenu: style.selectMenu }} onChange={onInverterChanged}>
                                <MenuItem key={0} dense value="0">
                                    <Box display="flex" alignItems="center">
                                        <ArrowDropDownCircleIcon style={{ color: allInverterOk ? 'green' : 'darkred', fontSize: 18, margin: 3, padding:0 }}/>
                                        <Box>所有機台 - {totalKw} KW</Box>
                                    </Box>
                                </MenuItem>
                                {inverterList.map((x, i) => (
                                    <MenuItem key={i + 1} dense value={x.index}>
                                    <Box display="flex" alignItems="center">
                                        <LabelIcon style={{ color: x.inverterOk ? 'green':'darkred', fontSize: 18, margin: 3, padding:0 }}/>
                                        <Box>{x.name}({x.index}) - {x.kw} KW</Box>
                                    </Box>                                        
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={5}>
                        <FormControl variant="outlined" size="small" fullWidth>
                            <Select variant="outlined" value={selectedMppt} classes={{ selectMenu: style.selectMenu }} onChange={(event) => setSelectedMppt(event.target.value)}>
                                <MenuItem key={0} dense value={0}>所有廻路</MenuItem>
                                {mppts && mppts[selectedInv] && mppts[selectedInv].mppts && mppts[selectedInv].mppts.map((x, i) => (
                                    <MenuItem key={i + 1} dense value={x.MpptID}>廻路 - {x.MpptID}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                </Grid>

                <Box pt={2}></Box>
                <Grid container>
                    <Grid item xs={4} classes={{ root: style.root }}>直流電壓</Grid>
                    <Grid item xs={4} classes={{ root: style.root }}>直流電流</Grid>
                    <Grid item xs={4} classes={{ root: style.root }}>直流功率</Grid>
                    <Grid item xs={4} classes={{ root: style.root }}>{round(DC_V, 1, 10)} V</Grid>
                    <Grid item xs={4} classes={{ root: style.root }}>{round(DC_A, 1, 0.05)} A</Grid>
                    <Grid item xs={4} classes={{ root: style.root }}>{round(DC_W / 1000.0, 1, 0)} kW</Grid>
                    <Grid item xs={12} classes={{ root: style.dividerRoot }}></Grid>
                    <Grid item xs={4} classes={{ root: style.root }}>交流電壓</Grid>
                    <Grid item xs={4} classes={{ root: style.root }}>交流電流</Grid>
                    <Grid item xs={4} classes={{ root: style.root }}>交流功率</Grid>
                    <Grid item xs={4} classes={{ root: style.root }}>{round(AC_V, 1, 10)} V</Grid>
                    <Grid item xs={4} classes={{ root: style.root }}>{round(AC_A, 1, 0.05)} A</Grid>
                    <Grid item xs={4} classes={{ root: style.root }}>{round(AC_W / 1000.0, 1, 0)} kW</Grid>
                    <Grid item xs={12} classes={{ root: style.dividerRoot }}><Divider /></Grid>
                    <Grid item xs={4} classes={{ root: style.root }}>變流器溫度</Grid>
                    <Grid item xs={4} classes={{ root: style.root }}>變流器即時η值</Grid>
                    <Grid item xs={4} classes={{ root: style.root }}>變流器累積η值</Grid>
                    <Grid item xs={4} classes={{ root: style.root }}>{round(INV_TEMP)} °C</Grid>
                    <Grid item xs={4} classes={{ root: style.root }}>{round(INV_EF)} %</Grid>
                    <Grid item xs={4} classes={{ root: style.root }}>{round(INV_EF_ALL, 1, INV_EF_ALL_STD_DIFF)} ({INV_EF_ALL_STD}) %</Grid>
                    <Grid item xs={12} classes={{ root: style.dividerRoot }}><Divider /></Grid>
                    <Grid item xs={4} classes={{ root: style.root }}>當日發電量</Grid>
                    <Grid item xs={4} classes={{ root: style.root }}>累積發電量</Grid>
                    <Grid item xs={4} classes={{ root: style.root }}>每KW發電量</Grid>
                    <Grid item xs={4} classes={{ root: style.root }}>{round(KW_TODAY)} KWh</Grid>
                    <Grid item xs={4} classes={{ root: style.root }}>{round(KW_TOTAL)} KWh</Grid>
                    <Grid item xs={4} classes={{ root: style.root }}>{round(KW_PER)} ({round(KW_PER2)}) kWh</Grid>
                    <Grid item xs={12} classes={{ root: style.dividerRoot }}><Divider /></Grid>
                    <Grid item xs={4} classes={{ root: style.root }}>落塵量</Grid>
                    <Grid item xs={4} classes={{ root: style.root }}>RA值</Grid>
                    <Grid item xs={4} classes={{ root: style.root }}>PR值</Grid>
                    <Grid item xs={4} classes={{ root: style.root }}>{round(DTY, 1, DTY_STD_DIFF)} ({DTY_STD}) %</Grid>
                    <Grid item xs={4} classes={{ root: style.root }}>{round(RA, 1, RA_STD_DIFF)} ({RA_STD}) %</Grid>
                    <Grid item xs={4} classes={{ root: style.root }}>{round(PR, 1, PR_STD_DIFF)} ({PR_STD}) %</Grid>
                </Grid>

            </Box>
            <Box pr={2} display="flex" justifyContent="flex-end" alignItems="center" bgcolor="rgba(255, 255, 255, 0.5)" borderRadius={10}>
                <Box pl={2} flexGrow={1} fontSize="0.6rem">
                    資料時間 : {(CAP_TIME instanceof moment) ? <Moment format="YYYY-MM-DD HH:mm:ss">{CAP_TIME}</Moment> : CAP_TIME}
                </Box>
                <Box>
                    <IconButton size="small" color="inherit" component={Link} to={`/station/${station.ID}`}><Assessment /></IconButton>
                    <IconButton size="small" color="inherit" onClick={onRefresh} ><Sync /></IconButton>
                </Box>
            </Box>
        </Box>

    );
}

export default StationCell;